module.exports = __webpack_public_path__ + "img/topics1.9f76eaf7.png";